module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES35UC4']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "details1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "detail-block-float detail-block-left"
  }, [_c('div', {
    staticClass: "detail-header"
  }, [_vm._v(_vm._s(_vm.labels['HRES35UC3']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES35UC3']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100"
  }, [_vm._v(" \n                    " + _vm._s(_vm.detail.tab1.codcomp1) + "-" + _vm._s(_vm.detail.tab1.codcomp2) + "-" + _vm._s(_vm.detail.tab1.codcomp3) + "-" + _vm._s(_vm.detail.tab1.codcomp4) + "-" + _vm._s(_vm.detail.tab1.codcomp5) + "-" + _vm._s(_vm.detail.tab1.codcomp6) + "-" + _vm._s(_vm.detail.tab1.codcomp7) + "\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100"
  }, [_vm._v(_vm._s(_vm.detail.tab1.desc_codcomp))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES35UC3']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100"
  }, [_vm._v(_vm._s(_vm.detail.tab1.desc_codpos))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES35UC3']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100"
  }, [_vm._v(_vm._s(_vm.detail.tab1.desc_codjob))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES35UC3']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100"
  }, [_vm._v(_vm._s(_vm.detail.tab1.desc_codbrlc))])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-block-float detail-block-right"
  }, [_c('div', {
    staticClass: "detail-header"
  }, [_vm._v(_vm._s(_vm.labels['HRES35UC3']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES35UC3']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100",
    class: {
      'text-red': (_vm.detail.tab1.codcomp1 != _vm.detail.tab1.codcom1 ||
        _vm.detail.tab1.codcomp2 != _vm.detail.tab1.codcom2 ||
        _vm.detail.tab1.codcomp3 != _vm.detail.tab1.codcom3 ||
        _vm.detail.tab1.codcomp4 != _vm.detail.tab1.codcom4 ||
        _vm.detail.tab1.codcomp5 != _vm.detail.tab1.codcom5 ||
        _vm.detail.tab1.codcomp6 != _vm.detail.tab1.codcom6 ||
        _vm.detail.tab1.codcomp7 != _vm.detail.tab1.codcom7)
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.detail.tab1.codcom1) + "-" + _vm._s(_vm.detail.tab1.codcom2) + "-" + _vm._s(_vm.detail.tab1.codcom3) + "-" + _vm._s(_vm.detail.tab1.codcom4) + "-" + _vm._s(_vm.detail.tab1.codcom5) + "-" + _vm._s(_vm.detail.tab1.codcom6) + "-" + _vm._s(_vm.detail.tab1.codcom7) + "\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100",
    class: {
      'text-red': _vm.detail.tab1.desc_codcomp != _vm.detail.tab1.desc_codcomp2
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.desc_codcomp2))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES35UC3']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100",
    class: {
      'text-red': _vm.detail.tab1.desc_codpos != _vm.detail.tab1.desc_codpos2
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.desc_codpos2))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES35UC3']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100",
    class: {
      'text-red': _vm.detail.tab1.desc_codjob != _vm.detail.tab1.desc_codjob2
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.desc_codjob2))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES35UC3']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100",
    class: {
      'text-red': _vm.detail.tab1.desc_codbrlc != _vm.detail.tab1.desc_codbrlc2
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.desc_codbrlc2))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES35UC3']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_vm._v(_vm._s(_vm.detail.tab1.descreq1))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ed01188!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres35u/detail.vue
// module id = 3747
// module chunks = 1